// Validation errors come back from the server keyed by the attribute they belong to ("end_date"),
// or by an attribute of a nested record ("game_levels.minimum_number_of_scans"), with an array of
// messages under each. These turn that into lines that read as sentences.
//
// They are rendered from plain state rather than set on the form. An error attached to a form
// control only clears when that control validates again, and half of this form's controls are
// disabled once an incentive has started - an error on one of those would leave the form invalid
// and the Save button disabled until the page was reloaded.
const GAME_LEVEL_KEY = /^game_levels(\.|$)/;

export const isGameLevelKey = key => GAME_LEVEL_KEY.test(key);

const humanise = value => value.replace(/_/g, ' ');

export const attributeLabel = (key) => {
  const [record, attribute] = key.split('.');
  const words = attribute ? `${humanise(record)} ${humanise(attribute)}` : humanise(record);

  return words.charAt(0).toUpperCase() + words.slice(1);
};

// Deduplicated: nothing dedupes across validators on the server, so one attribute can carry the
// same message twice, and saying it twice helps nobody. It also keeps every line distinct enough
// to use as a React key.
export const serverErrorMessages = (errors, include = () => true, label = attributeLabel) => (
  Object.keys(errors || {})
    .filter(include)
    .reduce((messages, key) => {
      const keyErrors = Array.isArray(errors[key]) ? errors[key] : [errors[key]];

      return messages.concat(keyErrors.map(error => `${label(key)} ${error}`));
    }, [])
    .filter((message, index, all) => all.indexOf(message) === index)
);

export default serverErrorMessages;
